<template>
  <header v-if="isMainHeader && windowSizeMixin.width > WINDOW_SIZE_SM"
          class="main-header"
          :class="selector">
    <div v-if="isMainHeader"
         class="main-header__inner homepage-header">
      <HeaderTop/>
    </div>
  </header>


  <header v-else-if="!isMainHeader"
          class="main-header"
          :class="selector">
    <div class="main-header__inner">
      <HeaderTop/>
      <div class="main-header__bottom container">
        <MainLogo class="main-header__logo"
                  :logo="logo"
                  :isVertical="false"/>

        <router-link-modified v-if="canShowFindVacancyMob && windowSizeMixin.width < WINDOW_SIZE_SM + 1"
                              :to="{name: 'find-vacancy'}"
                              class="main-header__find-work  base-btn  base-btn--green  d-sm-flex">
          {{ $tHeader('Find vacancy') }}
        </router-link-modified>

        <HeaderSearch v-if="windowSizeMixin.width > WINDOW_SIZE_MD"
                      class="main-header__search"/>

        <transition name="dropdown">
          <HeaderSearch
            v-if="windowSizeMixin.width < WINDOW_SIZE_MD + 1 && windowSizeMixin.width > WINDOW_SIZE_SM && isMobSearchOpen"
            v-click-out="onMobSearchClose"
            @search="onMobSearchClose"
            class="main-header__search"/>
        </transition>

        <transition name="fade">
          <MobMenu v-if="windowSizeMixin.width < WINDOW_SIZE_SM + 1 && isMobMenuOpen"
                   @close="onCloseMobMenus"
                   v-click-out="onMobMenuClose"
                   class="main-header__mob-menu"/>
        </transition>

        <div class="main-header__buttons">
          <button type="button"
                  key="search"
                  @click.prevent="onMobSearchToggle"
                  :class="isMobSearchOpen ? '_open' : null"
                  v-if="windowSizeMixin.width < WINDOW_SIZE_MD + 1 && windowSizeMixin.width > WINDOW_SIZE_SM"
                  class="main-header__buttons-item main-header__mob-btn base-btn base-btn--outline-grey">
            <transition name="fade">
              <BaseSvg v-if="isMobSearchOpen"
                       key="1"
                       name="ico-close"
                       width="1.6rem"
                       height="1.6rem"/>
              <BaseSvg v-else
                       key="2"
                       name="ico-loupe"
                       width="1.3rem"
                       height="1.3rem"/>
            </transition>
          </button>

          <div v-if="windowSizeMixin.width < WINDOW_SIZE_SM"
               class="main-header__bar">
            <button v-if="isLogged"
                    @click.prevent="onShowChat" type="button" class="main-header__bar-btn">
              <BaseSvg name="ico-chat-stroke"/>
              <transition name="fade">
                <span v-if="getUnreadCount > 0" class="main-header__bar-btn-note">{{ getUnreadCount }}</span>
              </transition>
            </button>

            <transition name="fade">
              <router-link-modified v-if="typeof bookmarksCount === 'number'"
                                    :to="{name: 'account-my-vacancies', query: {currentTab: 2}}"
                                    class="main-header__bar-btn">
                <BaseSvg name="ico-heart-outline"
                         width="1.7rem"
                         height="1.5rem"
                         class="_stroke  buzz-out"/>
                <span class="main-header__bar-btn-note  _blue">{{ bookmarksCount }}</span>
              </router-link-modified>
            </transition>

            <button v-if="isLogged"
                    @click.prevent="openNotifications"
                    type="button"
                    :class="newNotificationCount ? '_new' :  null"
                    class="main-header__bar-btn  _bell">
              <!--add ^ _new for ring-->
              <BaseSvg name="ico-bell-stroke"/>
              <transition name="fade">
                <span v-if="newNotificationCount > 0" class="main-header__bar-btn-note">{{
                    newNotificationCount
                  }}</span>
              </transition>
            </button>
          </div>

          <!--<button v-if="isLogged"
                  key="account-menu"
                  type="button"
                  :class="isMobMenuAccountOpen ? '_open' : null"
                  @click.prevent="onMobMenuAccountToggle"
                  class="main-header__buttons-item main-header__mob-btn base-btn base-btn&#45;&#45;outline-grey d-none d-sm-inline-flex">
            <transition name="fade">
              <BaseSvg v-if="isMobMenuAccountOpen"
                       key="1"
                       name="ico-close"
                       width="2.1rem"
                       height="1.4rem"/>
              <BaseSvg v-else
                       key="2"
                       name="ico-user"
                       width="1.6rem"
                       height="1.6rem"/>
            </transition>
          </button>
          <router-link-modified v-else
                                key="auth"
                                :to="{name: 'auth'}"
                                tag="div"
                                class="main-header__buttons-item main-header__mob-btn base-btn base-btn&#45;&#45;outline-grey d-none d-sm-inline-flex">
            <BaseSvg name="ico-user"
                     width="1.6rem"
                     height="1.6rem"/>
          </router-link-modified>-->

          <button type="button"
                  key="mob-menu"
                  @click.prevent="onMobMenuToggle"
                  :class="isMobMenuOpen ? '_open' : null"
                  class="main-header__buttons-item main-header__mob-btn base-btn d-none d-sm-inline-flex">
            <transition name="fade">
              <BaseSvg v-if="isMobMenuOpen"
                       key="1"
                       name="ico-close"
                       width="2.1rem"
                       height="1.4rem"/>
              <BaseSvg v-else
                       key="2"
                       name="ico-burger"
                       width="2.1rem"
                       height="1.4rem"/>
            </transition>
          </button>
          <!---->
          <router-link-modified
            v-if="showPostVacancyButton"
            class="main-header__buttons-item base-btn base-btn--blue d-sm-none  specific-account-new-vacancy"
            :to="{ name: 'account-new-vacancy' }"
          >
            <span class="base-btn__text">{{ $tHeader('Post vacancy') }}</span>
          </router-link-modified>
          <template v-if="showPostResumeButton && isLogged">
            <router-link-modified
              v-if="isAgent || isPartner || isEmployee"
              class="main-header__buttons-item base-btn base-btn--green d-sm-none"
              :to="isEmployee ? '/find-vacancy' : '/account/register-candidate'"
            >
              {{ isEmployee ? $tHeader('Find vacancy') : $tResumesBase('Register a candidate') }}
            </router-link-modified>
            <button
              v-else
              class="main-header__buttons-item base-btn base-btn--green d-sm-none  specific-account-new-resume"
              @click.prevent="$vModal.open('after-respond-without-resume')"
            >
              <span class="base-btn__text">{{ $tHeader('Post resume') }}</span>
            </button>
          </template>
          <router-link-modified
            v-else-if="showPostResumeButton"
            class="main-header__buttons-item base-btn base-btn--green d-sm-none  specific-account-new-resume"
            :to="{name: 'auth', query: {'open-resume-chat-bot': 'true'}}"
          >
            <span class="base-btn__text">{{ $tHeader('Post resume') }}</span>
          </router-link-modified>

          <!---->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import {mapMutations, mapState, mapGetters} from 'vuex'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import {EMPLOYER} from '@/constants/usersTypes'
  import {WINDOW_SIZE_MD, WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import MainLogo from './MainLogo'
  import HeaderSearch from './HeaderSearch'
  import MobMenu from './MobMenu'
  import HeaderTop from './HeaderTop'

  export default {
    mixins: [windowSizeMixin],
    components: {
      HeaderTop,
      MobMenu,
      HeaderSearch,
      MainLogo
    },
    data() {
      return {
        isMobSearchOpen: false,
        isMobMenuOpen: false,
        logo: {
          vertical: globalConfigs.header.logo_vertical,
          horizontal: globalConfigs.header.logo_horizontal,
          home: globalConfigs.header.logo_home
        },
        scrollPosition: 0,
        scrollPositionOld: 0,
        hideHeader: false,
        finger: '',

        WINDOW_SIZE_MD,
        WINDOW_SIZE_SM,

      }
    },
    computed: {
      ...mapGetters('user', [
        'bookmarksCount',
        'isLogged',
        'isAgent',
        'isPartner',
        'isEmployee',
      ]),
      ...mapState('user/userNotifications', [
        'newNotificationCount',
      ]),
      isMainHeader() {
        return this.isRouteNameMixin('home')
          || this.isRouteNameMixin('about')
      },
      isHomePage() {
        return this.isRouteNameMixin('home')
      },
      selector() {
        return {
          '_hide': this.scrollPosition > 60 &&
            this.scrollPosition > this.scrollPositionOld &&
            !this.isMobSearchOpen &&
            !this.isMobMenuOpen
        }
      },
      showPostVacancyButton() {
        const profile = this.$store.state.user.profile
        return profile && profile.user_type === EMPLOYER
      },
      showPostResumeButton() {
        const profile = this.$store.state.user.profile
        return profile && profile.user_type !== EMPLOYER
      },
      getUnreadCount() {
        return this.$intercom ? this.$intercom.unreadCount : 0
      },
      canShowFindVacancyMob() {
        return !this.isRouteNameMixin('find-vacancy') && !this.isRouteNameMixin('find-vacancy-questionnaire')
      }
    },
    methods: {
      ...mapMutations('user/userNotifications', [
        'openNotifications',
      ]),
      onMobSearchToggle() {
        this.isMobSearchOpen = !this.isMobSearchOpen
      },
      onMobSearchClose() {
        this.isMobSearchOpen = false
      },
      onMobMenuToggle() {
        this.isMobMenuOpen = !this.isMobMenuOpen
      },
      onMobMenuClose() {
        this.isMobMenuOpen = false
      },
      updateScroll() {
        this.scrollPositionOld = this.scrollPosition
        this.scrollPosition = window.scrollY
      },
      onCloseMobMenus() {
        this.isMobMenuOpen = false
      },
      onShowChat() {
        this.$intercom.show()
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll)
    },
    watch: {
      '$route'() {
        this.onCloseMobMenus()
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.updateScroll)
    }
  }
</script>

<style lang="less">

</style>
